/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

module.exports = stubTrue;



//////////////////
// WEBPACK FOOTER
// ./~/card-validator/~/lodash/lang/isNative.js
// module id = 822
// module chunks = 47